module.exports = __webpack_public_path__ + "media/images/icons/icon-bag-637ef45d8fe076bf91cfdc86116cb5e9.svg";